import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';

import ProductsPage from './ProductsPageComponent';
import actions from './actions';
import coreActions from '../core/actions';

const allActions = { ...actions, ...coreActions };

const mapStateToProps = (state) => ({
  items: state.products,
  productTemplates: state.productSettingsTemplates,
  ...state.productSettings,
  config: state.config,
  notification: state.notification,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ProductsPage);
